@if (view(); as view) {
  <div class="content" coreActivitySection="Builder">
    <app-builder-node [node]="view.root" [pageId]="pageId()" [language]="language()"/>
  </div>
} @else {
  <p class="unavailable" role="status">This page is unavailable.</p>
}
